import styled, { css } from 'styled-components';

import { Div } from './Generic';

const Hero = styled(Div)`
  ${({ theme }) => css`
    box-shadow: inset 0 -1px 0 ${theme.colors.gray[250]};
  `}
`;

export default Hero;
